<div class="toolbar">
    <div class="toolbar__logo">
        <img src="images/lokOsLogo.svg" alt="PIMS Logo" />
        <span class="toolbar__title">{{ 'pims' | translate }}</span>
        <span class="toolbar__divider" aria-hidden="true"></span>
        <span class="toolbar__subtitle"
            >Product Inventory <br />
            Management System</span
        >
    </div>

    <div class="user-profile" [matMenuTriggerFor]="profileMenu">
        <div class="profile-avatar-wrapper">
            <img
                class="profile-img"
                [src]="profileImageUrl || 'images/members.svg'"
                (error)="onImageError()"
                #img
                alt="profile"
            />
            <span class="status-indicator"></span>
        </div>
        <div class="profile-desc">
            <span class="user-name">{{ userProfile?.name }}</span>
            <span class="user-role">
                @if (displayProfile) {
                    <span class="user-profile-title">{{ displayProfile }}</span>
                }
                @if (displayActiveRole) {
                    <span class="user-active-role">{{ displayActiveRole }}</span>
                }
            </span>
        </div>
        <img class="profile-arrow" src="images/chevron-down.svg" alt="arrow down" />
        <mat-menu #profileMenu="matMenu" class="mat-elevation-z3">
            <pims-user-profile-menu />
        </mat-menu>
    </div>
</div>
